import styled, { css } from 'styled-components';
import { th, variants } from 'style/theme';

export const Select = styled.div`
  ${variants('variant', {
    light: css`
      > p {
        color: ${th('colors.white')};
      }
    `,
    dark: css`
      > p {
        color: ${th('colors.black')};
      }
    `
  })}

  display: flex;
  align-items: center;
  opacity: ${({ isSelected }) => (isSelected ? '1' : '0.5')};
  cursor: pointer;

  > img {
    border-radius: 50%;
  }

  > p {
    margin-left: 12px;
    font-size: 15px;
  }

  &:hover {
    opacity: 1;
  }
`;

export const Container = styled.div`
  ${variants('size', {
    medium: css`
      margin-bottom: 22px;
      width: 240px;

      > ${Select} > img {
        height: 48px;
        width: 48px;
      }
    `,
    extralarge: css`
      margin-bottom: 40px;
      width: 280px;

      > ${Select} > img {
        height: 70px;
        width: 70px;
      }
    `
  })}

  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;
